import { apiFetch } from './api';

export interface DeviceSuggestionPayload {
  name: string;
  brand?: string;
  category?: string;
  note?: string;
  contactEmail?: string;
}

export async function suggestDevice(payload: DeviceSuggestionPayload): Promise<void> {
  await apiFetch<unknown>('/device-suggestions', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
